import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Icon = styled(FontAwesomeIcon)({
    fontSize: 46,
    color: '#FF8F00',
    margin: '4px auto',
});

export const Header = styled.p`
    color: ${({ theme }) => theme.colors.neutral900};
    margin: 12px auto;
    font-size: 20px;
    font-weight: 600;
    line-height: 36px;
`;

export const Text = styled.p`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    margin-bottom: 20px;
    width: 322px;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;
